module.exports = __webpack_public_path__ + "img/ba.7a937b48.svg";